export default __webpack_public_path__ + "static/media/No55Closed.bf81fb83.jpg";